import { RasterLayerState } from '../../../../core/outputs/annotation/annotation-shared/state/layers/raster-layer-state';
import { VectorLayerState } from '../../../../core/outputs/annotation/annotation-shared/state/layers/vector-layer-state';
import { AnnotationState2D } from '../../annotation-shared/state/root/annotation-state-2d';

export type ImageAnnotationLayerState = RasterLayerState | VectorLayerState;

export class ImageAnnotationState extends AnnotationState2D {}
